// extracted by mini-css-extract-plugin
export const validationAlertWrap = "index-module--validation-alert-wrap--1qO-W";
export const validationAlert = "index-module--validation-alert--NT94e";